import React from "react";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import HelpHeader from "../HelpHeader";
import FAQ from "./FAQ";
import { colors } from "../Colors";
import { SUPPORT_TEL } from "../../constants/support";
import "./Help.css";

class Help extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <div className="help-container">
          {/* === Header Row (Back, Title, Call + HelpHeader) === */}
          <div className="help-header-row">
            {/* Left: Back Button */}
            <button
              onClick={() => this.props.history.push({ pathname: "/dashboard" })}
              className="back-button"
              aria-label="Back to dashboard"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 19l-7-7 7-7"
                  stroke="#333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <line
                  x1="8"
                  y1="12"
                  x2="20"
                  y2="12"
                  stroke="#333"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {/* Center: Title */}
            <h1 className="help-title" style={{ color: colors.darkBlue }}>
              Help &amp; FAQ
            </h1>

            {/* Right: Call + HelpHeader container */}
            <div className="actions-container">
              <button
                className="action-button-xs btn"
                onClick={() => (window.location.href = SUPPORT_TEL)}
              >
                Call
              </button>
              <HelpHeader />
            </div>
          </div>

          {/* === FAQ Section === */}
          <div className="help-button">
            <FAQ />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Help);
